( function ( $ ) {

    let $sort_toggle;
    let $sorting_by;
    let $tbody;
    let $programs;

    function set_element_vars () {
        $sort_toggle = $( '.program-table thead th.sort-toggle' );
        $sorting_by = $( '.sorting-by', $sort_toggle );
        $tbody = $( '.program-table tbody' );
        $programs = $( 'tr', $tbody );
    }

    $(function () {
        set_element_vars();

        $sort_toggle.click( function () {
            let new_sort = $sort_toggle.hasClass( 'asc' ) ? 'desc' : 'asc';
            let sorting_by_text = ( new_sort == 'asc' ) ? 'A-Z' : 'Z-A';
            ['asc', 'desc'].forEach( ( val ) => {
                $sort_toggle.toggleClass( val, () => new_sort == val );
            });
            $sorting_by.html( sorting_by_text );
            $programs.reverse();
            $tbody.html( $programs );
        });

        $programs.click( function ( e ) {
            if ( $(this).css('display') == 'block' ) {
                // bail if click is on anchor tag or if mobile view
                return;
            }
            let $link = $( 'a', this );
            if ( $link.length ) {
                window.location.href = $link.attr( 'href' );
            }
        });

    });

})( jQuery );